/* eslint-disable */
export default {
  noActiveCalls: '沒有正在進行的通話',
  currentCall: '目前通話',
  ringCall: '撥打中通話',
  onHoldCall: '通話保留',
  otherDeviceCall: '我的其他裝置上仍有通話',
  confirmation: '確認',
  confirmMergeToConference: '添加至電話會議？',
  mergeToConference: '合併',
  conferenceCall: '電話會議',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
